/* 
    [지점 데이터]
    1. 지점번호
    2. 지점명
    3. 구매자 번호 리스트(FK) - 구매자 데이터 기준
*/

const testStoreData = [
    {
        storeNo: 1,
        storeName: "관저점",
        buyerNo: [1, 2, 3],
    },
    {
        storeNo: 2,
        storeName: "목동점",
        buyerNo: [4, 5, 6],
    },
    {
        storeNo: 3,
        storeName: "둔산점",
        buyerNo: [1, 3, 5],
    },
    {
        storeNo: 4,
        storeName: "탄방점",
        buyerNo: [2, 4, 6],
    },
];

export default testStoreData;